import { useAtomValue } from 'jotai';

import SelectionState from '@/features/clickhouse-trends/components/selections-sidebar/state/selections.state';
import { useListDeviceTrendPoints } from '@/hooks/query-hooks/gaia-api/trends';

export const useSelectionGroups = () => {
  const { data: deviceTrendPoints } = useListDeviceTrendPoints();

  const groupDevices = useAtomValue(SelectionState.groupedDevices);

  return groupDevices(deviceTrendPoints);
};
